import { API_URL } from "env";
import { useEffect, useState } from "react";

const PermissionEditModal = ({id}:{id:string[]}) => {
    const [permissionName, setPermissionName] = useState("");
    const [module, setModule] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    async function handleSubmit() {
        try {
            for (const permId of id) {
                const response = await fetch(`${API_URL}api/v1/be/permission/${permId}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({
                        display_name: permissionName,
                        module: module,
                        description: description,
                    }),
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                console.log('Permission updated:', data);
            }
        }
        catch (error) {
            console.error('Error updating permission:', error);
        }
    }
    useEffect(() => {
        async function fetchPermissionDetails(id: string) {
            try {
                setLoading(true);
                const response = await fetch(`${API_URL}api/v1/be/permission/${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                setLoading(false);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setPermissionName(data.data.display_name || "");
                setModule(data.data.module || "");
                setDescription(data.data.description || "");
            } catch (error) {
                console.error('Error fetching permission details:', error);
            }
        }
        if (id) {
            fetchPermissionDetails(id[0]);
        }
    }, [id]);
    return (
        <div className="flex flex-col gap-4 max-h-[70vh] overflow-y-auto ">
            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <div className="flex flex-col gap-2">
                        <label htmlFor="permissionName" className="font-medium">Permission Name</label>
                        <input type="text" id="permissionName" className="w-full p-2 border rounded-lg" placeholder="Enter permission name" value={permissionName} onChange={(e) => setPermissionName(e.target.value)} />
                    </div>
                    <div className="flex flex-col gap-2">
                        <label htmlFor="module" className="font-medium">Module</label>
                        <input type="text" id="module" className="w-full p-2 border rounded-lg" placeholder="Enter module name" value={module} onChange={(e) => setModule(e.target.value)} />   
                    </div>
                    <div className="flex flex-col gap-2">
                        <label htmlFor="description" className="font-medium">Description</label>
                        <textarea id="description" className="w-full p-2 border rounded-lg" placeholder="Enter description" rows={4} value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="flex flex-col gap-1">
                        <small className="text-gray-500">Effected id: {id.join(", ")}.</small>
                        <small className="text-gray-500">Note: Action field is not editable.</small>
                    </div>
                    <button 
                        onClick={handleSubmit}
                        className="px-4 py-2 bg-blue-600 !text-white rounded-lg hover:bg-blue-700 transition-colors">
                        Save Changes
                    </button>
                </>
            )}
        </div>
    )
}
export default PermissionEditModal;